import "@/index.scss";
import { Color } from "@skillscratch/shared-constants";
import "modern-normalize/modern-normalize.css";
import { MediaLogos } from "@/components/MediaLogos";
import { SafePaddingContainer } from "@/components/SafePaddingContainer";


export function StaticLoading() {
  return (
    <div className="flex flex-col h-screen overflow-y-scroll bg-white">
      <SafePaddingContainer orientation="header" className='h-full'>
        <div className='flex flex-col gap-6 justify-center h-full translate-y-8'>
          <h1 className='text-center text-blue text-6xl font-extrabold mb-0'>Scratch</h1>
          <div className='bg-sky-50 text-blue text-3xl font-semibold py-3 px-6 flex items-center justify-center w-fit mx-auto rounded-lg'>
            Win up to $4.6M
          </div>
          <div className='mx-auto w-5/6'>
            <ProgressBar progress={97} />
          </div>
        </div>
      </SafePaddingContainer>
      <SafePaddingContainer orientation="footer">
          <div
            className='font-semibold text-2xl text-center opacity-20 mb-4'
          >
            As seen on
          </div>
          <MediaLogos />
        </SafePaddingContainer>
    </div>
  );
}

function ProgressBar({ progress }: { progress: number }) {
  return (
    <div
      style={{
        position: "relative",
        height: "6vw",
        background: "#d9d9d9",
        borderRadius: "3vw",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${9 + progress * 98}%`,
          borderRadius: "3vw",
          background: Color.blue,
          transition: "width 100ms",
          willChange: "width",
        }}
      />
    </div>
  );
}